/* Product Gallery — Scroll-snap carousel with peek */
(function() {
  'use strict';

  var gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  var track = gallery.querySelector('[data-gallery-track]');
  var slides = track ? track.querySelectorAll('.product-gallery__slide') : [];
  var prevBtn = gallery.querySelector('[data-gallery-prev]');
  var nextBtn = gallery.querySelector('[data-gallery-next]');
  var thumbs = gallery.querySelectorAll('[data-thumb-index]');
  var dots = gallery.querySelectorAll('[data-dot-index]');
  var current = 0;
  var total = slides.length;

  if (total === 0) return;

  function goTo(index) {
    current = ((index % total) + total) % total;
    var slide = slides[current];
    if (slide) {
      slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
    setActive(current);
  }

  function setActive(idx) {
    thumbs.forEach(function(t) {
      t.classList.toggle('is-active', parseInt(t.dataset.thumbIndex) === idx);
    });
    dots.forEach(function(d) {
      d.classList.toggle('is-active', parseInt(d.dataset.dotIndex) === idx);
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      goTo(parseInt(thumb.dataset.thumbIndex));
    });
  });

  /* Track active slide as the user scrolls */
  var scrollTimer = null;
  track.addEventListener('scroll', function() {
    if (scrollTimer) clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function(s, i) {
        var d = Math.abs(s.offsetLeft + s.clientWidth / 2 - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      if (best !== current) {
        current = best;
        setActive(current);
      }
    }, 80);
  }, { passive: true });
})();
